import { useVaultWorkflowCardsStyles } from "./VaultWorkflowCards.styles";
import { IVaultWorkflowCardsProps } from "./VaultWorkflowCards.types";

const HEADING_ID = "vault-workflows-heading";

export const VaultWorkflowCards = ({
  cards,
  onOpenCard,
}: IVaultWorkflowCardsProps): JSX.Element => {
  const styles = useVaultWorkflowCardsStyles();

  return (
    <section className={styles.section} aria-labelledby={HEADING_ID}>
      <h2 id={HEADING_ID} className={styles.heading}>
        Vault workflows
      </h2>
      <ul className={styles.grid}>
        {cards.map(({ id, title, description, buttonLabel, icon: Icon }) => (
          <li key={id} className={styles.card}>
            <div className={styles.cardHeader}>
              <Icon aria-hidden="true" />
              <h3 className={styles.cardTitle}>{title}</h3>
            </div>
            <p className={styles.description}>{description}</p>
            <button
              type="button"
              className={styles.button}
              onClick={() => onOpenCard?.(id)}
            >
              {buttonLabel}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
